module.exports = __webpack_public_path__ + "static/media/11.48963792.jpg";